import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      background: '#ffffff',
      minHeight: '100vh',
      fontFamily: '"Quicksand", sans-serif',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header Navigation */}
      <Header />

      {/* Main Content Section - Side by Side Layout */}
      <section style={{
        padding: '2.5rem 0',
        background: 'white'
      }}>
        <div className="container">
          <div className="row align-items-center">
            {/* Hero Section - Left Column */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div style={{
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}>
                <h1 className="display-4 fw-bold mb-4" style={{ lineHeight: '1.2', color: '#1f2937' }}>
                  Welcome to
                  <br />
                  <span style={{ color: '#fbbf24' }}>Publication Hub</span>
                </h1>
                <p className="mb-4" style={{ fontSize: '1.3rem', lineHeight: '1.6', fontWeight: '500', color: '#6b7280' }}>
                  Discover a comprehensive collection of research papers, white papers, newsletters, and industry insights.
                  Our platform provides access to valuable knowledge and expertise from leading professionals.
                </p>
              </div>
            </div>

            {/* Knowledge Repository Section - Right Column */}
            <div className="col-lg-6">
              <div style={{
                textAlign: 'center',
                background: 'linear-gradient(to right, rgb(145, 234, 228), rgb(134, 168, 231), rgb(127, 127, 213))',
                padding: '1.5rem',
                borderRadius: '16px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 6px 24px rgba(0, 0, 0, 0.08)'
              }}>
                <h2 className="display-5 fw-bold mb-4" style={{ color: '#1f2937' }}>
                  Knowledge Repository
                </h2>
                <p className="lead text-muted mb-4">
                  Access our comprehensive collection of publications and insights
                </p>

                <div className="row g-4">
                  {/* Research Papers Widget */}
                  <div className="col-6">
                    <div
                      style={{
                  cursor: 'pointer',
                        padding: '1rem',
                        height: '100%',
                  display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                  alignItems: 'center',
                        transition: 'all 0.3s ease',
                        borderRadius: '8px'
                }}
                onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.backgroundColor = 'transparent';
                      }}
                      onClick={() => navigate('/research-papers')}
                    >
                      <div style={{ fontSize: '3rem', color: '#fbbf24', marginBottom: '1rem' }}>📄</div>
                      <div className="fw-semibold" style={{ fontSize: '1.2rem', color: '#1f2937' }}>Research Papers</div>
              </div>
            </div>

                  {/* Newsletters Widget */}
                  <div className="col-6">
                    <div
                style={{
                  cursor: 'pointer',
            padding: '1rem',
                        height: '100%',
              display: 'flex',
              flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                transition: 'all 0.3s ease',
                        borderRadius: '8px'
              }}
              onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              }}
              onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                e.target.style.backgroundColor = 'transparent';
                      }}
                      onClick={() => navigate('/newsletters')}
                    >
                      <div style={{ fontSize: '3rem', color: '#fbbf24', marginBottom: '1rem' }}>📰</div>
                      <div className="fw-semibold" style={{ fontSize: '1.2rem', color: '#1f2937' }}>Newsletters</div>
            </div>
          </div>
        </div>

                <div className="row text-center mt-3">
                  {/* Weekly Highlights Widget */}
                  <div className="col-6">
                    <div
                  style={{
                        cursor: 'pointer',
                        padding: '1rem',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transition: 'all 0.3s ease',
                        borderRadius: '8px'
                  }}
                  onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.backgroundColor = 'transparent';
                      }}
                      onClick={() => navigate('/weekly-highlights')}
                    >
                      <div style={{ fontSize: '3rem', color: '#fbbf24', marginBottom: '1rem' }}>📊</div>
                      <div className="fw-semibold" style={{ fontSize: '1.2rem', color: '#1f2937' }}>Weekly Highlights</div>
                    </div>
                  </div>

                  {/* Blogs Widget */}
                  <div className="col-6">
                    <div
                  style={{
                        cursor: 'pointer',
                        padding: '1rem',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        transition: 'all 0.3s ease',
                        borderRadius: '8px'
                  }}
                  onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                        e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.backgroundColor = 'transparent';
                  }}
                      onClick={() => navigate('/blogs')}
                >
                      <div style={{ fontSize: '3rem', color: '#fbbf24', marginBottom: '1rem' }}>📝</div>
                      <div className="fw-semibold" style={{ fontSize: '1.2rem', color: '#1f2937' }}>Blogs</div>
            </div>
          </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage; 